<template>
  <div v-if="btn">
    <div class="title">
      <mdb-icon :icon="icon" /> <mdb-icon :icon="labelIcon" />{{label}}
      <mdb-btn v-if="btn" class="px-2 py-0" @click="click" :icon="btnIcon">{{btn}}</mdb-btn>
    </div>
    <slot class="ml-3" v-if="mode"></slot>
  </div>
  <div v-else>
    <div class="title pointer" @click="click">
      <mdb-icon :icon="icon" /> <mdb-icon :icon="labelIcon" /> {{label}}</div>
    <slot class="ml-3" v-if="mode"></slot>
  </div>
</template>
<script>
import { mdbIcon, mdbRow, mdbCol } from 'mdbvue';
export default {
  name: 'FolderLabel',
  components: { mdbIcon },
  props: ['label-icon', 'label', 'btn', 'btnIcon', 'open'],
  data: function () {
    return {
      mode: this.open
    }
  },
  computed: {
    icon () {
      return this.mode ? 'angle-down' : 'angle-right'
    }
  },
  methods: {
    click () {
      this.mode = !this.mode
      if (this.btn) {
        this.btnLabel = this.mode ? '닫기' : '보기'
      }
    }
  }
}
</script>
